import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import EditBrand from "../../ui/EditBrand";
import AddBrand from "../../ui/AddBrand";
import ProductService from "../../services/ProductService";
import PagedCardTable from "../../ui/PagedCardTable";

const ProductsBrand = () => {
  const navigate = useNavigate();
  const [reloadKey, setReloadKey] = useState(0);
  const [alert, setAlert] = useState(null);
  const [oldBrandData, setOldBrandData] = useState();
  const [onAddBrand, setOnAddBrand] = useState(false);
  const [onEditBrand, setOnEditBrand] = useState(false);

  const fetchAvailable = useCallback(
    (params) =>
      ProductService.getReferencePage("Brands", { ...params, isDeleted: 0 }),
    []
  );
  const fetchArchived = useCallback(
    (params) =>
      ProductService.getReferencePage("Brands", { ...params, isDeleted: 1 }),
    []
  );

  const onArchiveHandler = (id, archiveOrRestored) => {
    ProductService.archiveOrRestoreReference("Brand", id, archiveOrRestored)
      .then(() => {
        setAlert({
          severity: "success",
          text:
            archiveOrRestored === 1
              ? "Élément archivé avec succès"
              : "Élément restauré avec succès",
        });
        setReloadKey((key) => key + 1);
      })
      .catch(() =>
        setAlert({ severity: "error", text: "Erreur : opération impossible" })
      );
  };

  const onEditBrandHandler = (row) => {
    setOldBrandData({
      idBrand: row.id,
      name: row.name,
      description: row.description,
    });
    setOnEditBrand(true);
  };
  const onViewProductsHandler = (brandId) => {
    sessionStorage.setItem("typePage", "brand");
    sessionStorage.setItem("idBrand", brandId);
    navigate(`/getListProductsInfo`);
  };

  const availableColumns = [
    {
      label: "Libellé",
      render: (row) => row.name,
    },
    {
      label: "Description",
      render: (row) => row.description || "-",
    },
    {
      label: "DC",
      width: "14%",
      render: (row) => row.creationDate,
    },

    {
      label: "Modifier",
      width: "10%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn bg-gray btn-sm"
          title="Modifier"
          onClick={() => onEditBrandHandler(row)}
        >
          <i className="fas fa-pencil-alt"></i>
        </button>
      ),
    },
    {
      label: "Voir Plus",
      width: "10%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn bg-black btn-sm"
          title="Voir les produits"
          onClick={() => onViewProductsHandler(row.id)}
        >
          <i className="fas fa-shopping-cart"></i>
        </button>
      ),
    },
    {
      label: "Archiver",
      width: "10%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn btn-danger btn-sm"
          title="Archiver"
          onClick={() => onArchiveHandler(row.id, 1)}
        >
          <i className="fas fa-trash"></i>
        </button>
      ),
    },
  ];

  const archivedColumns = [
    {
      label: "Libellé",
      render: (row) => row.name,
    },
    {
      label: "DC",
      width: "20%",
      render: (row) => row.creationDate,
    },

    {
      label: "Restaurer",
      width: "12%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn bg-gray-dark btn-sm"
          title="Restaurer"
          onClick={() => onArchiveHandler(row.id, 0)}
        >
          <RestoreFromTrashRoundedIcon />
        </button>
      ),
    },
  ];

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-tags mr-2"></i>Marques
              </h4>
              <small className="text-muted">Gérez les marques de produits</small>
            </div>
            <div className="mt-2 mt-sm-0">
              <button
                className="btn btn-outline-dark mr-2"
                onClick={() => navigate(`/uploadExcel?type=brands`)}
              >
                <i className="fas fa-file-excel mr-1"></i>
                Importer un fichier Excel
              </button>
              <button className="btn btn-dark" onClick={() => setOnAddBrand(true)}>
                <i className="fas fa-plus mr-1"></i>
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="content">
        <div className="container-fluid">
          <PagedCardTable
            title="Les marques disponibles"
            icon="fas fa-tags"
            fetchPage={fetchAvailable}
            columns={availableColumns}
            reloadKey={reloadKey}
          />
          <PagedCardTable
            title="Les marques non disponibles"
            icon="fas fa-archive"
            badgeClass="badge-secondary"
            fetchPage={fetchArchived}
            columns={archivedColumns}
            reloadKey={reloadKey}
            emptyText="Aucun élément archivé"
          />
        </div>
      </div>
      {alert && (
        <Snackbar
          open
          autoHideDuration={2500}
          onClose={() => setAlert(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={() => setAlert(null)} severity={alert.severity}>
            {alert.text}
          </Alert>
        </Snackbar>
      )}
      {onAddBrand && <AddBrand setOnAddBrand={setOnAddBrand} />}
      {onEditBrand && (
        <EditBrand
          setOnEditBrand={setOnEditBrand}
          oldBrandData={oldBrandData}
        />
      )}
    </div>
  );
};
export default ProductsBrand;
